import CloseIcon from '@mui/icons-material/Close'
import { useContext } from 'react'
import { Spinner } from 'react-bootstrap'
import { APP_CONSTANTS } from 'src/consumer/constants'
import { JournalContext } from 'src/consumer/context/JournalContext'
import { PlayerContext } from 'src/consumer/context/PlayerContext'
import { SetupContext } from 'src/consumer/context/SetupContext'
import { getJournalCardDetails } from 'src/consumer/helpers/journalHelper'
import { getColorStyle } from 'src/consumer/helpers/tileCardHelper'
import {
  getCategoryCardDetails,
  getCategoryCardIdToDetailsMap,
} from '../../helpers/categoryCardHelper'
import { getCategoryListMap, getCourseCardDetails } from '../../helpers/courseCardHelper'
import { resetPlayerData } from '../../helpers/playerHelper'
import { useFetch } from '../../services/index'
import { StyledLine } from '../Journal/JournalStyles'
import {
  EmptyPageImage,
  EmptyPageImageMain,
  EmptyPageImagesContainer,
  EmptyPageScreenContainer,
  EmptyPageScreenText,
  SelectedCategoryIcon,
  StyledBackButton,
  StyledBrowseByCategoryDrawer,
  StyledCardInfo,
  StyledCardInfoSeparator,
  StyledCategory,
  StyledCategoryContent,
  StyledCategoryHeaderLandscape,
  StyledCategoryHeaderPortrait,
  StyledCategoryList,
  StyledContentBackground,
  StyledContentCard,
  StyledContentList,
  StyledContentParent,
  StyledCourseCategory,
  StyledCourseTitle,
  StyledPlayButton,
  StyledSelectMenu,
} from './BrowserByCategoryStyle'
import SelectedCategoryImage from 'src/assets/selected_category.png'

const renderCategoryList = (categoryList, selectedCategory, setSelectedCategory, cardsType) => {
  return categoryList.map((category, index) => {
    const { categoryTitle, categoryImage, bgColor, categoryId } = getCategoryCardDetails(
      category,
      cardsType,
    )
    const isSelected = categoryId === selectedCategory?.selectedCardId
    return (
      <StyledCategory
        isSelected={isSelected}
        key={index}
        onClick={() =>
          setSelectedCategory({ selectedCardTitle: categoryTitle, selectedCardId: categoryId })
        }
      >
        {isSelected && <SelectedCategoryIcon src={SelectedCategoryImage} />}
        <>{categoryTitle}</>
      </StyledCategory>
    )
  })
}

const renderContentList = (
  data,
  setupData,
  setPlayerData,
  playerData,
  tilePolicyId,
  setJournalData,
  selectedCategory,
  setSelectedCategory,
) => {
  let categoryListMap

  if (data?.items?.length === 0) {
    categoryListMap = getCategoryListMap(setupData)
    const emptyCardData = categoryListMap?.get(selectedCategory?.selectedCardId)?.emptyPageScreen

    return (
      <EmptyPageScreenContainer>
        <EmptyPageImagesContainer>
          {emptyCardData?.images?.[0] && (
            <EmptyPageImage left src={`${APP_CONSTANTS.MEDIA_URL}${emptyCardData?.images?.[0]}`} />
          )}
          {emptyCardData?.images?.[1] && (
            <EmptyPageImageMain src={`${APP_CONSTANTS.MEDIA_URL}${emptyCardData?.images?.[1]}`} />
          )}
          {emptyCardData?.images?.[2] && (
            <EmptyPageImage right src={`${APP_CONSTANTS.MEDIA_URL}${emptyCardData?.images?.[2]}`} />
          )}
        </EmptyPageImagesContainer>
        <EmptyPageScreenText heading>{emptyCardData?.title}</EmptyPageScreenText>
        <EmptyPageScreenText>{emptyCardData?.subtext}</EmptyPageScreenText>
      </EmptyPageScreenContainer>
    )
  }

  return data?.items?.map((card, index) => {
    let title
    let category
    let image

    if (data?.itemType === 'course') {
      const { courseTitle, courseCategory, verticalIconImg } = getCourseCardDetails(
        card,
        getCategoryListMap(setupData),
      )
      title = courseTitle
      category = courseCategory
      image = verticalIconImg
    } else if (data?.itemType === 'journal') {
      const {
        journalTitle,
        journalCategory,
        journalIconImage,
        journalCoverImage,
        journalVerticalImage,
      } = getJournalCardDetails(card, getCategoryListMap(setupData))
      title = journalTitle
      category = journalCategory
      image = journalVerticalImage
    } else if (data?.itemType === 'teacher') {
      title = card?.teacher?.name
      image = card?.teacher?.profilePicId
    }

    function handleClick() {
      if (data?.itemType === 'course') {
        setPlayerData({
          ...resetPlayerData(playerData),
          showPlayer: true,
          selectedCard: playerData.showPIP ? playerData?.selectedCard : card,
          source: 'tile',
          id: tilePolicyId,
        })
      }
      if (data?.itemType === 'journal') {
        setSelectedCategory(false)
        setJournalData({
          showJournal: true,
          callSource: 'tilespage',
          data: { ...card?.journal, callSourceId: tilePolicyId, sourceName: 'tile' },
          pageState: '',
          subscription: card?.journal?.subscription?.id,
        })
      }
    }

    return (
      <StyledContentCard key={index} onClick={handleClick}>
        <StyledContentBackground imgURL={APP_CONSTANTS.MEDIA_URL + image}>
          <StyledCardInfo>
            <StyledCourseCategory>{category}</StyledCourseCategory>
            <StyledCardInfoSeparator />
            <StyledCourseTitle>{title}</StyledCourseTitle>

            {data?.itemType === 'course' && <StyledPlayButton>Play</StyledPlayButton>}

            {data?.itemType === 'journal' && <StyledLine />}
            {data?.itemType === 'journal' && <StyledLine />}
            {data?.itemType === 'journal' && <StyledLine />}
          </StyledCardInfo>
        </StyledContentBackground>
      </StyledContentCard>
    )
  })
}

const BrowseByCategory = (props) => {
  const {
    selectedCategory,
    setSelectedCategory,
    categoryList,
    tileId,
    cardsType,
    policyId,
    cardsCategory,
    tilePolicyId,
    fromMore,
    categoryHeader,
  } = props
  const { playerData, setPlayerData } = useContext(PlayerContext)
  const { setupData } = useContext(SetupContext)
  const { loading, data, error } = useFetch(
    '/api/secure/tile/ontap',
    `&tileType=${tileId}&policyId=${policyId || ''}&cardCategory=${cardsCategory}&id=${
      fromMore ? cardsType : selectedCategory?.selectedCardId
    }&metaCategoryType=${fromMore ? cardsType : selectedCategory?.selectedCardId}`,
    'web',
  )
  const { journalData, setJournalData } = useContext(JournalContext)

  const categoryIdToDetailMap = getCategoryCardIdToDetailsMap(categoryList, cardsType)

  return (
    <>
      <StyledBrowseByCategoryDrawer
        anchor="bottom"
        open={!selectedCategory ? selectedCategory : true}
        color={getColorStyle(
          '#000',
          '',
          categoryIdToDetailMap?.get(selectedCategory?.selectedCardId)?.bgColor,
          'solid',
        )}
      >
        <StyledBackButton onClick={() => setSelectedCategory(false)}>
          <CloseIcon />
        </StyledBackButton>

        <StyledCategoryContent>
          <StyledCategoryHeaderLandscape>
            {fromMore ? categoryHeader : selectedCategory?.selectedCardTitle}
          </StyledCategoryHeaderLandscape>

          <StyledCategoryHeaderPortrait>
            {fromMore ? (
              categoryHeader
            ) : (
              <StyledSelectMenu
                value={selectedCategory?.selectedCardId}
                onChange={(e) => {
                  setSelectedCategory({
                    selectedCardTitle: categoryIdToDetailMap?.get(e.target.value)?.title,
                    selectedCardId: e.target.value,
                  })
                }}
              >
                {categoryList?.map((category, index) => {
                  const { categoryTitle, categoryImage, bgColor, categoryId } =
                    getCategoryCardDetails(category, cardsType)
                  return (
                    <option key={index} value={categoryId}>
                      {categoryTitle}
                    </option>
                  )
                })}
              </StyledSelectMenu>
            )}
          </StyledCategoryHeaderPortrait>

          <StyledContentParent>
            {!fromMore && (
              <StyledCategoryList>
                {renderCategoryList(categoryList, selectedCategory, setSelectedCategory, cardsType)}
              </StyledCategoryList>
            )}

            {loading ? (
              <Spinner animation="border" variant="light" size="md" style={{ margin: '0 auto' }} />
            ) : (
              <StyledContentList id="cardContainerScrollable">
                {renderContentList(
                  data,
                  setupData,
                  setPlayerData,
                  playerData,
                  tilePolicyId,
                  setJournalData,
                  selectedCategory,
                  setSelectedCategory,
                )}
              </StyledContentList>
            )}
          </StyledContentParent>
        </StyledCategoryContent>
      </StyledBrowseByCategoryDrawer>
    </>
  )
}

export default BrowseByCategory
